module.exports = __webpack_public_path__ + "img/GallerySample1.01ab9a7b.jpg";